import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import Cookies from "js-cookie";
import MessageToster from "./component/MessageToster";

export const getAuthToken = () => Cookies.get("token");

export const getDeviceId = () => {
    if (typeof window !== "undefined") {
        let deviceId =
            localStorage.getItem("device_id") ||
            localStorage.getItem("deviceid");
        if (!deviceId || !deviceId.trim()) {
            deviceId = `web_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            localStorage.setItem("device_id", deviceId);
            localStorage.setItem("deviceid", deviceId);
        }
        return deviceId.trim();
    }
    return "";
};

export const getRawDeviceToken = () => {
    if (typeof window !== "undefined") {
        return (
            localStorage.getItem("devicetoken") ||
            sessionStorage.getItem("devicetoken") ||
            Cookies.get("devicetoken") ||
            ""
        );
    }
    return "";
};

export const getDeviceToken = () => {
    const rawToken = getRawDeviceToken();
    if (!rawToken) return "";

    if (rawToken.includes("$")) {
        return rawToken;
    }

    const deviceId = getDeviceId();
    return deviceId ? `${rawToken}$${deviceId}` : rawToken;
};

let isLoggingOut = false;
let lastSessionExpiredTime = 0;

export const setManualLogout = (flag = true) => {
    isLoggingOut = flag;
    if (typeof window !== "undefined") {
        if (flag) {
            sessionStorage.setItem("manual_logout", "true");
            setTimeout(() => {
                isLoggingOut = false;
                sessionStorage.removeItem("manual_logout");
            }, 3500);
        } else {
            sessionStorage.removeItem("manual_logout");
        }
    }
};

export const isManualLogout = () => {
    return (
        isLoggingOut ||
        (typeof window !== "undefined" &&
            sessionStorage.getItem("manual_logout") === "true")
    );
};

export const useHandleUnauthorized = () => {
    const navigate = useNavigate();

    return useCallback(() => {
        // If user manually logged out, suppress "session expired" error toast
        if (isManualLogout()) {
            return;
        }

        const now = Date.now();
        // Debounce: prevent duplicate session expired triggers within 3 seconds
        if (now - lastSessionExpiredTime < 3000) {
            return;
        }
        lastSessionExpiredTime = now;

        Cookies.remove("token");
        Cookies.remove("userdata");
        Cookies.remove("username");
        Cookies.remove("devicetoken");
        sessionStorage.removeItem("mid");
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("devicetoken");
        localStorage.removeItem("devicetoken");

        MessageToster("error", "Session expired. Please log in again.", {
            id: "session_expired_alert",
        });
        setTimeout(() => navigate("/", { replace: true }), 500);
    }, [navigate]);
};

export { createAdminToken, adminDirectLogin } from "./utils/adminAuth";